// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import jwt_decode from "jwt-decode";

// import { AUTH_TOKEN } from "constants/AuthConstant";
// import { REFRESH_TOKEN } from "constants/AuthConstant";
// import FirebaseService from "services/FirebaseService";
// import AuthService from "services/AuthService";

// export const initialState = {
//   loading: false,
//   user: null,
//   message: "",
//   showMessage: false,
//   redirect: "",
//   token: localStorage.getItem(AUTH_TOKEN) || null,
//   refresh: localStorage.getItem(REFRESH_TOKEN) || null,
//   didRefresh: false,
// };

// export const signIn = createAsyncThunk(
//   "auth/login",
//   async (data, { rejectWithValue }) => {
//     const { email, password } = data;
//     try {
//       const response = await AuthService.login({ email, password });
//       const token = response.data.access_token;
//       const rfToken = response.data.refresh_token;
//       localStorage.setItem(AUTH_TOKEN, token);
//       localStorage.setItem(REFRESH_TOKEN, rfToken);
//       return { token, rfToken };
//     } catch (err) {
//       return rejectWithValue(err.response.data.data.message || "Erreur");
//     }
//   }
// );

// export const signUp = createAsyncThunk(
//   "auth/register",
//   async (data, { rejectWithValue }) => {
//     const { username, email, password } = data;

//     try {
//       const response = await AuthService.register({
//         email,
//         password,
//         username,
//       });
//       const token = response.data.access_token;
//       const rfToken = response.data.refresh_token;

//       localStorage.setItem(AUTH_TOKEN, token);
//       localStorage.setItem(REFRESH_TOKEN, rfToken);
//       return { token, rfToken };
//     } catch (err) {
//       return rejectWithValue(err.response.data.data.message || "Erreur");
//     }
//   }
// );

// export const refresh = createAsyncThunk(
//   "auth/refresh",
//   async (args, { getState, rejectWithValue }) => {
//     try {
//       let newToken = getState().auth.refresh;

//       const response = await AuthService.refresh();
//       const rfToken = response.data;
//       localStorage.setItem(AUTH_TOKEN, newToken);
//       localStorage.setItem(REFRESH_TOKEN, rfToken);

//       return { rfToken, newToken };
//     } catch (err) {
//       return rejectWithValue(err.response?.data.data.message || "Erreur");
//     }
//   }
// );

// export const signOut = createAsyncThunk("auth/logout", async () => {
//   localStorage.removeItem(AUTH_TOKEN);
//   localStorage.removeItem(REFRESH_TOKEN);
// });

// export const getUser = createAsyncThunk(
//   "auth/currentUser",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await AuthService.getUser();
//       const { id, email, username, roles, privileges } = response.data;

//       return { id, email, username, roles, privileges };
//     } catch (err) {
//       return rejectWithValue(err.response?.data.data.message || "Erreur");
//     }
//   }
// );

// export const signInWithGoogle = createAsyncThunk(
//   "auth/signInWithGoogle",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await AuthService.loginInOAuth();
//       const token = response.data.token;
//       localStorage.setItem(AUTH_TOKEN, token);
//       return token;
//     } catch (err) {
//       return rejectWithValue(err.response?.data.data.message || "Erreur");
//     }
//   }
// );

// export const signInWithFacebook = createAsyncThunk(
//   "auth/signInWithFacebook",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await AuthService.loginInOAuth();
//       const token = response.data.token;
//       localStorage.setItem(AUTH_TOKEN, token);
//       return token;
//     } catch (err) {
//       return rejectWithValue(err.response?.data.data.message || "Erreur");
//     }
//   }
// );

// export const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     authenticated: (state, action) => {
//       state.loading = false;
//       state.redirect = "/";
//       state.token = action.payload;
//     },
//     showAuthMessage: (state, action) => {
//       state.message = action.payload;
//       state.showMessage = true;
//       state.loading = false;
//     },
//     hideAuthMessage: (state) => {
//       state.message = "";
//       state.showMessage = false;
//     },
//     signOutSuccess: (state) => {
//       state.loading = false;
//       state.token = null;
//       state.redirect = "/";
//     },
//     showLoading: (state) => {
//       state.loading = true;
//     },
//     signInSuccess: (state, action) => {
//       state.loading = false;
//       state.token = action.payload;
//     },
//     setRefresh: (state, action) => {
//       state.refresh = true; // added that
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(signIn.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(signIn.fulfilled, (state, action) => {
//         state.loading = false;
//         state.redirect = "/";
//         state.token = action.payload.token;
//         state.refresh = action.payload.rfToken;
//       })
//       .addCase(signIn.rejected, (state, action) => {
//         state.message = action.payload;
//         state.showMessage = true;
//         state.loading = false;
//       })
//       .addCase(signOut.fulfilled, (state) => {
//         state.loading = false;
//         state.token = null;
//         state.refresh = null;

//         state.user = {};
//         state.redirect = "/";
//       })
//       .addCase(signOut.rejected, (state) => {
//         state.loading = false;
//         state.token = null;
//         state.refresh = null;
//         state.user = {};
//         state.redirect = "/";
//       })
//       .addCase(signUp.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(signUp.fulfilled, (state, action) => {
//         state.loading = false;
//         state.redirect = "/";
//         state.token = action.payload.token;
//         state.refresh = action.payload.rfToken;
//       })
//       .addCase(signUp.rejected, (state, action) => {
//         state.message = action.payload;
//         state.showMessage = true;
//         state.loading = false;
//       })
//       .addCase(refresh.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(refresh.fulfilled, (state, action) => {
//         state.loading = false;
//         state.token = action.payload.newToken;
//         state.refresh = action.payload.rfToken;
//         state.didRefresh = true;
//         //window.location.reload();
//       })
//       .addCase(refresh.rejected, (state, action) => {
//         state.message = action.payload;
//         state.showMessage = true;
//         state.loading = false;
//       })
//       .addCase(getUser.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(getUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = action.payload;
//       })
//       .addCase(getUser.rejected, (state, action) => {
//         state.message = action.payload;
//         state.showMessage = true;
//         state.loading = false;
//       });
//     // .addCase(signInWithGoogle.pending, (state) => {
//     //   state.loading = true;
//     // })
//     // .addCase(signInWithGoogle.fulfilled, (state, action) => {
//     //   state.loading = false;
//     //   state.redirect = "/";
//     //   state.token = action.payload;
//     // })
//     // .addCase(signInWithGoogle.rejected, (state, action) => {
//     //   state.message = action.payload;
//     //   state.showMessage = true;
//     //   state.loading = false;
//     // })
//     // .addCase(signInWithFacebook.pending, (state) => {
//     //   state.loading = true;
//     // })
//     // .addCase(signInWithFacebook.fulfilled, (state, action) => {
//     //   state.loading = false;
//     //   state.redirect = "/";
//     //   state.token = action.payload;
//     // })
//     // .addCase(signInWithFacebook.rejected, (state, action) => {
//     //   state.message = action.payload;
//     //   state.showMessage = true;
//     //   state.loading = false;
//     // });
//   },
// });

// export const {
//   authenticated,
//   showAuthMessage,
//   hideAuthMessage,
//   signOutSuccess,
//   showLoading,
//   signInSuccess,
//   setRefresh,
// } = authSlice.actions;

// export default authSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { REFRESH_TOKEN } from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import AuthService from "services/AuthService";

export const initialState = {
  loading: false,
  user: null,
  message: "",
  showMessage: false,
  redirect: "",
  token: Cookies.get(AUTH_TOKEN) ?? null,
  refresh: Cookies.get(REFRESH_TOKEN) ?? null,
  didRefresh: false,
};

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      const response = await AuthService.login({ email, password });
      const token = response.data.access_token;
      const rfToken = response.data.refresh_token;
      Cookies.set(AUTH_TOKEN, token);
      Cookies.set(REFRESH_TOKEN, rfToken);
      return { token, rfToken };
    } catch (err) {
      return rejectWithValue(err.response.data.data.message || "Erreur");
    }
  }
);

export const signUp = createAsyncThunk(
  "auth/register",
  async (data, { rejectWithValue }) => {
    const { username, email, password } = data;

    try {
      const response = await AuthService.register({
        email,
        password,
        username,
      });
      const token = response.data.access_token;
      const rfToken = response.data.refresh_token;

      Cookies.set(AUTH_TOKEN, token);
      Cookies.set(REFRESH_TOKEN, rfToken);
      return { token, rfToken };
    } catch (err) {
      return rejectWithValue(err.response.data.data.message || "Erreur");
    }
  }
);

export const refresh = createAsyncThunk(
  "auth/refresh",
  async (args, { getState, rejectWithValue }) => {
    try {
      let newToken = getState().auth.refresh;

      const response = await AuthService.refresh();
      const rfToken = response.data;
      Cookies.set(AUTH_TOKEN, newToken);
      Cookies.set(REFRESH_TOKEN, rfToken);

      return { rfToken, newToken };
    } catch (err) {
      Cookies.remove(AUTH_TOKEN);
      Cookies.remove(REFRESH_TOKEN);
      return rejectWithValue(err.response?.data.data.message || "Erreur");
    }
  }
);

export const signOut = createAsyncThunk("auth/logout", async () => {
  Cookies.remove(AUTH_TOKEN);
  Cookies.remove(REFRESH_TOKEN);
});

export const getUser = createAsyncThunk(
  "auth/currentUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.getUser();
      const { id, email, username, roles, privileges } = response.data;

      return { id, email, username, roles, privileges };
    } catch (err) {
      return rejectWithValue(err.response?.data.data.message || "Erreur");
    }
  }
);

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth();
      const token = response.data.token;
      Cookies.set(AUTH_TOKEN, token);
      return token;
    } catch (err) {
      return rejectWithValue(err.response?.data.data.message || "Erreur");
    }
  }
);

export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth();
      const token = response.data.token;
      Cookies.set(AUTH_TOKEN, token);
      return token;
    } catch (err) {
      return rejectWithValue(err.response?.data.data.message || "Erreur");
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
    setRefresh: (state, action) => {
      state.refresh = true; // added that
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload.token;
        state.refresh = action.payload.rfToken;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.refresh = null;

        state.user = {};
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.refresh = null;
        state.user = {};
        state.redirect = "/";
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload.token;
        state.refresh = action.payload.rfToken;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(refresh.pending, (state) => {
        state.loading = true;
      })
      .addCase(refresh.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.newToken;
        state.refresh = action.payload.rfToken;
        state.didRefresh = true;
        //window.location.reload();
      })
      .addCase(refresh.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
        state.token = null;
        state.refresh = null;
        state.user = {};
        state.redirect = "/";
      })
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
    // .addCase(signInWithGoogle.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(signInWithGoogle.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.redirect = "/";
    //   state.token = action.payload;
    // })
    // .addCase(signInWithGoogle.rejected, (state, action) => {
    //   state.message = action.payload;
    //   state.showMessage = true;
    //   state.loading = false;
    // })
    // .addCase(signInWithFacebook.pending, (state) => {
    //   state.loading = true;
    // })
    // .addCase(signInWithFacebook.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.redirect = "/";
    //   state.token = action.payload;
    // })
    // .addCase(signInWithFacebook.rejected, (state, action) => {
    //   state.message = action.payload;
    //   state.showMessage = true;
    //   state.loading = false;
    // });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
  setRefresh,
} = authSlice.actions;

export default authSlice.reducer;
